const roots = document.querySelectorAll('[data-ks-product-main]');

for (const root of roots) {
  const formatPriceText = (value) => value
    .replace(/Rs\.?\s*/g, '₹')
    .replace(/(\d[\d,]*)\.00\b/g, '$1');

  const formatDisplayedPrices = () => {
    const priceElements = root.querySelectorAll('product-price .price, product-price .compare-at-price, .ks-sticky-cart__summary strong');
    for (const element of priceElements) {
      const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
      let textNode;
      while ((textNode = walker.nextNode())) {
        const formatted = formatPriceText(textNode.nodeValue);
        if (formatted !== textNode.nodeValue) textNode.nodeValue = formatted;
      }
    }
  };

  const parseMoney = (value) => {
    const match = value.match(/[0-9][0-9,]*(?:\.[0-9]{1,2})?/);
    return match ? Number(match[0].replace(/,/g, '')) : NaN;
  };

  const updateSavings = () => {
    const priceRoot = root.querySelector('product-price');
    if (!priceRoot) return;

    const currentPrice = parseMoney(priceRoot.querySelector('.price')?.textContent || '');
    const compareElement = priceRoot.querySelector('.compare-at-price');
    const comparePrice = parseMoney(compareElement?.textContent || '');
    const hasSavings = Number.isFinite(currentPrice) && Number.isFinite(comparePrice) && comparePrice > currentPrice;
    const priceLine = compareElement?.parentElement || priceRoot;
    priceLine.classList.add('ks-product-page__price-line');
    let savings = priceRoot.querySelector('[data-ks-pdp-savings]');

    if (hasSavings && !savings) {
      savings = document.createElement('span');
      savings.className = 'ks-product-page__savings';
      savings.dataset.ksPdpSavings = '';
    }

    if (savings && savings.parentElement !== priceLine) priceLine.append(savings);
    if (!savings) return;
    const nextText = hasSavings
      ? `₹${new Intl.NumberFormat('en-IN', { maximumFractionDigits: 0 }).format(comparePrice - currentPrice)} OFF`
      : '';

    if (savings.textContent !== nextText) savings.textContent = nextText;
    if (savings.hidden === hasSavings) savings.hidden = !hasSavings;
  };

  const refreshDisplayedPricing = () => {
    formatDisplayedPrices();
    updateSavings();
  };

  refreshDisplayedPricing();
  const priceObserver = new MutationObserver(refreshDisplayedPricing);
  for (const priceRoot of root.querySelectorAll('product-price, .ks-sticky-cart__summary')) {
    priceObserver.observe(priceRoot, { childList: true, characterData: true, subtree: true });
  }

  const sticky = root.querySelector('[data-ks-sticky-cart]');
  const originalAdd = root.querySelector("product-form-component button[name='add'], product-form-component .add-to-cart-button");
  const picker = root.querySelector('variant-picker, [data-variant-picker]');

  if (sticky && originalAdd) {
    const observer = new IntersectionObserver(
      ([entry]) => {
        const visible = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.dataset.visible = String(visible);
        sticky.setAttribute('aria-hidden', String(!visible));
      },
      { threshold: 0 }
    );
    observer.observe(originalAdd);

    sticky.querySelector('[data-ks-sticky-add]')?.addEventListener('click', () => originalAdd.click());
    sticky.querySelector('[data-ks-scroll-size]')?.addEventListener('click', () => {
      (picker || originalAdd).scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  for (const checker of root.querySelectorAll('[data-ks-delivery]')) {
    const input = checker.querySelector('[data-ks-pincode]');
    const message = checker.querySelector('[data-ks-pincode-message]');
    checker.querySelector('[data-ks-pincode-check]')?.addEventListener('click', () => {
      const valid = /^[1-9][0-9]{5}$/.test(input.value.trim());
      message.textContent = valid
        ? 'Delivery and COD availability for this pincode will be confirmed at checkout.'
        : 'Please enter a valid 6-digit Indian pincode.';
      message.dataset.valid = String(valid);
    });
  }

  for (const link of document.querySelectorAll('a[href="#ks-size-details"]')) {
    link.addEventListener('click', (event) => {
      const details = document.querySelector('#ks-size-details');
      if (!details) return;
      event.preventDefault();
      details.open = true;
      details.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }
}
